<template>
  <div>
    <b-container class="bv-example-row mt-3">
      <b-alert :show="messageObject.success.count"
                dismissible
                @dismissed="messageObject.success.count=0"
                @dismiss-count-down="successCountChanged"
                >{{messageObject.success.content}}
      </b-alert>
      <b-alert :show="messageObject.warning.count"
                variant="danger"
                dismissible
                @dismissed="messageObject.warning.count=0"
                @dismiss-count-down="warningCountChanged"
                >{{messageObject.warning.content}}
      </b-alert>
      <b-card-group deck>
        <b-card title="登入">
          <b-form>
            <b-form-group>
              <b-form-input v-model="account.userid" type="text" size="lg" required placeholder="電子郵件"></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input v-model="account.passwd" type="password" size="lg" required placeholder="密碼"></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input v-model="account.imgobj.value" type="text" size="lg" required placeholder="驗證碼"></b-form-input>
            </b-form-group>
            <b-form-group>
              <img v-bind:src="account.imgobj.url"/>
            </b-form-group>
          </b-form>
          <b-row align-h="between" class="mb-4">
            <b-col md="auto">
              <b-form-checkbox
                v-model="rememberaccount"
                value=true
                unchecked-value=false
                >記住我的帳號</b-form-checkbox>
            </b-col>
            <b-col md="auto">
              <span v-b-modal.modal-forgetpassword>忘記密碼</span>
              <b-modal
                id="modal-forgetpassword"
                ref="forgetpasswordmodal"
                title="忘記密碼"
                @show="resetForgetPasswordModal"
                @hidden="resetForgetPasswordModal"
                @ok="handleForgetPasswordOk"
              >
                <form ref="form" @submit.stop.prevent="handleSubmit">
                  <b-form-group
                    label="請輸入您的Email"
                    label-for="email-input"
                    invalid-feedback="Email格式錯誤"
                    valid-feedback="格式正確"
                    :state="account.state"
                  >
                  <b-input-group size="lg">
                  <b-input-group-prepend is-text>
                    <b-icon icon="envelope"></b-icon>
                  </b-input-group-prepend>
                    <b-form-input
                      id="email-input"
                      v-model="account.email"
                      :state="account.state"
                      required
                    ></b-form-input>
                  </b-input-group>
                  </b-form-group>
                </form>
              </b-modal>
            </b-col>
            <b-col>
              <!-- <span v-b-modal.modal-resendemail>重新發送驗證信</span> -->
              <b-modal
                id="modal-resendemail"
                ref="resendemailmodal"
                title="重新發送驗證信"
                @show="resendEmailModal"
                @hidden="resendEmailModal"
                @ok="handleresendEmailOk"
              >
                <form ref="form" @submit.stop.prevent="handleSubmit">
                  <b-form-group
                    label="請輸入您的Email"
                    label-for="email-input"
                    invalid-feedback="Email格式錯誤"
                    valid-feedback="格式正確"
                    :state="account.state"
                  >
                  <b-input-group size="lg">
                  <b-input-group-prepend is-text>
                    <b-icon icon="envelope"></b-icon>
                  </b-input-group-prepend>
                    <b-form-input
                      id="email-input"
                      v-model="account.email"
                      :state="account.state"
                      required
                    ></b-form-input>
                  </b-input-group>
                  </b-form-group>
                </form>
              </b-modal>
            </b-col>
          </b-row>
          <b-button block @click="sumbitEvent()" size="lg" variant="primary">登入</b-button>
          <b-button block @click="loginLine()" size="lg" class="btn-line">
            <img src="static/img/btn_line_base.png" alt="Kitten" class="d-inline-block logo">使用Line登入
          </b-button>
        </b-card>
        <b-card title="註冊">
          <b-form-group
            label-for="register-name"
            label-cols-sm="3"
            label-align-sm="right"
            label-class="required"
          >
            <template v-slot:label>
              <span class="text-danger">*</span> 姓名
            </template>
            <b-form-input
              v-model="registerObject.username.value"
              placeholder="請輸入姓名"
              :state="registerObject.username.state"
              aria-describedby="register-name-feedback"
              id="register-name"
            ></b-form-input>
            <b-form-invalid-feedback id="register-name-feedback">
              {{registerObject.username.message}}
            </b-form-invalid-feedback>
          </b-form-group>

        <b-form-group
          label="電子郵件"
          label-for="register-email"
          label-cols-sm="3"
          label-align-sm="right"
        >
          <template v-slot:label>
            <span class="text-danger">*</span> 電子郵件
          </template>
          <b-form-input
            v-model="registerObject.email.value"
            id="register-email"
            placeholder="請輸入Email"
            :state="registerObject.email.state"
            aria-describedby="register-email-feedback"
            >
          </b-form-input>
            <b-form-invalid-feedback id="register-email-feedback">
              {{registerObject.email.message}}
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label-for="register-group"
          label-cols-sm="3"
          label-align-sm="right"
        >
          <template v-slot:label>
            <span class="text-danger">*</span> 群組
          </template>
          <b-form-select
            id="register-group"
            v-model="registerObject.group.value"
            :options="grouplist"
            :state="registerObject.group.state"
            aria-describedby="register-group-feedback"
          >
          </b-form-select>
            <b-form-invalid-feedback id="register-group-feedback">
              {{registerObject.group.message}}
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="單位"
          label-for="register-agency"
          label-cols-sm="3"
          label-align-sm="right"
        >
          <b-form-input
            v-model="registerObject.agency.value"
            placeholder="請輸入單位"
            id="register-agency">
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="職稱"
          label-for="register-role"
          label-cols-sm="3"
          label-align-sm="right"
        >
          <b-form-input
            v-model="registerObject.role.value"
            placeholder="請輸入職稱"
            id="register-role">
          </b-form-input>
        </b-form-group>

        <b-form-group
          label-for="register-phone"
          label-cols-sm="3"
          label-align-sm="right"
          description="手機號碼請輸入10碼，例：0912345678
          電話號碼如有分機請加「#」，例：051234567#1234"
        >
          <template v-slot:label>
            <span class="text-danger">*</span> 電話/手機
          </template>
          <b-form-input
            v-model="registerObject.phone.value"
            :state="registerObject.phone.state"
            placeholder="請輸入電話號碼"
            aria-describedby="register-phone-feedback"
            id="register-phone">
          </b-form-input>
          <b-form-invalid-feedback id="register-phone-feedback">
            {{registerObject.phone.message}}
          </b-form-invalid-feedback>
        </b-form-group>


        <b-form-group
          label-for="register-password"
          label-cols-sm="3"
          label-align-sm="right"
          description="英文字母與數字組合，長度8個字元以上不含空白字元"
        >
          <template v-slot:label>
            <span class="text-danger">*</span> 密碼
          </template>
          <b-form-input
            v-model="registerObject.userpwd.first.value"
            :state="registerObject.userpwd.first.state"
            type="password"
            aria-describedby="register-firstpassword-feedback"
            id="register-password">
          </b-form-input>
          <b-form-invalid-feedback id="register-firstpassword-feedback">
              {{registerObject.userpwd.first.message}}
            </b-form-invalid-feedback>
        </b-form-group>


        <b-form-group
          label-for="register-pwdconfirm"
          label-cols-sm="3"
          label-align-sm="right"
          description="確認密碼"
        >
          <template v-slot:label>
            <span class="text-danger">*</span> 確認密碼
          </template>
          <b-form-input
            v-model="registerObject.userpwd.second.value"
            :state="registerObject.userpwd.second.state"
            type="password"
            aria-describedby="register-pwdconfirm-feedback"
            id="register-pwdconfirm">
          </b-form-input>
          <b-form-invalid-feedback id="register-pwdconfirm-feedback">
              {{registerObject.userpwd.second.message}}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="訂閱"
          label-for="register-subscrible"
          label-cols-sm="3"
          label-align-sm="right"
          description="訂閱農作物交易行情及氣象預警通知"
        >
        <b-form-checkbox
          id="register-subscrible"
          v-model="registerObject.subscribile.value"
          name="check-button" switch
          >
          </b-form-checkbox>
        </b-form-group>
        <b-button @click="registerprocess" block size="lg" variant="primary">註冊</b-button>
        </b-card>
      </b-card-group>
    </b-container>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Login_sub',
  data(){
    return {
      rememberaccount: false,
      ifregisterprocess:false,
      grouplist: [],
      isSucessMsgShow: 0,
      errors: [],
      imageurl: String,
      hiddenCode: String,
      imageObj: String,
      email: '',
      account: {
        userid: null,
        passwd: null,
        state: null,
        email: null,
        imgobj: {
          url: null,
          hiddenCode: null,
          value: null,
        }
      },
      registerObject: {
        username: {
          value: null,
          state: null,
          message: "必填欄位"
        },
        userpwd: {
          first: {
            value: null,
            state: null,
            message: "必填欄位"

          },
          second: {
            value: null,
            state: null,
            message: "必填欄位"
          },
        },
        email: {
          value: null,
          state: null,
          message: "必填欄位"
        },
        group: {
          value: null,
          state: null,
          message: "必填欄位"
        },
        phone: {
          value: null,
          state: null,
          message: "必填欄位"
        },
        agency: {
          value: null,
          state: null
        },
        role: {
          value: null,
          state: null
        },
        subscribile: {
          value: false,
          state: null,
        }
      },
      messageObject: {
        warning: {
          //show: false,
          content: null,
          count: 0
        },
        success: {
          //show: false,
          content: null,
          count: 0
        },
        dismissSecs: 3,
      },
      emailState: null,
      wanringAlerCount: 0,
      wanringMsg: '',
      successMsg: '',
      accountValue: '',
      pwdValue: '',
      imgCodeValue: '',
      dismissSecs: 99999,
      send: false,
      apiImageCode: (data) => this.userRequest.post("API/Default/GetImageCode", data),
      apiLogin: (data) => this.userRequest.post("API/Default/Login", data),
      apiForgetPassword: (data) => this.userRequest.post("API/Default/LastPass", data),
      // apiPasswordReset: (data) => this.userRequest.post("API/Default/LastPassReset", data),
      apiAccountGroupSignList: (data) => this.userRequest.post("/API/Default/AccountGroupSignList", data),
      apiInsertAccount: (data) => this.userRequest.post("/API/Default/InsertAccount", data),
      apiResendCertification: (data) => this.userRequest.post("/API/Default/ResendCertification", data),

      apiLineOption: (data) => this.userRequest.post("/API/Default/LineOption", data),

    }
  },
  created() {
    if(localStorage.getItem('yunlinaccount'))
    {
      this.account.userid = localStorage.getItem('yunlinaccount')
      this.rememberaccount = true
    }
  },
  mounted(){
    this.FunctionToken(this.getImageCode, {})
    this.FunctionToken(this.getAccountGroupSignList, {})
  },
  watch: {
    email: function(newValue) {
      this.checkFormValidity(newValue)
    },
    rememberaccount: function(){
      if(this.rememberaccount == "false"){
        // console.log("取消記住帳號")
        localStorage.removeItem('yunlinaccount');
      }
    },
    'registerObject.username.value' (val) {
      if(!this.send){
        this.registerObject.username.state = this.IsNull(val)==''?false:true
      }
    },
    'registerObject.group.value' (val) {
      if(!this.send){
        this.registerObject.group.state = this.IsNull(val)==''?false:true
      }
    },
    'registerObject.email.value' (val) {
      if(!this.send){
        if(this.IsNull(val)=='') {
          this.registerObject.email.state = false
          this.registerObject.email.message = "必填欄位"
        }
        else if(!this.validEmail(val))
        {
          this.registerObject.email.state = false
          this.registerObject.email.message = "Email格式錯誤"
        }
        else
        {
          this.registerObject.email.state = true
        }
      }
    },
    'registerObject.phone.value' (val) {
      if(!this.send){
        this.registerObject.phone.state = this.IsNull(val)==''?false:true
      }
    },
    'registerObject.userpwd.first.value' (val) {
      if(!this.send){
        // console.log(val)
        if(val.length==0)
        {
          this.registerObject.userpwd.first.message = "必填欄位"
          this.registerObject.userpwd.first.state = false
        }
        else if(val.length<8)
        {
          this.registerObject.userpwd.first.message = "密碼至少8個字元"
          this.registerObject.userpwd.first.state = false
        }
        else
        {
          let numasc=0;
          let charasc=0;
          for (let i=0; i < val.length; i++)
          {
            let asciiNumber = val.substr(i, 1).charCodeAt()
            // console.log(asciiNumber)
            if (asciiNumber >= 48 && asciiNumber <= 57) {
              numasc=1;
            }
            if ((asciiNumber >= 65 && asciiNumber <= 90)||(asciiNumber >= 97 && asciiNumber <= 122)) {
              charasc=1;
            }
          }
          // console.log([numasc, charasc])
          if(numasc==0)
          {
            this.registerObject.userpwd.first.message = "密碼必須含有數字";
            this.registerObject.userpwd.first.state = false
          }
          else if(charasc==0)
          {
            this.registerObject.userpwd.first.message = "密碼必須含有字母";
            this.registerObject.userpwd.first.state = false
          }
          else
          {
            this.registerObject.userpwd.first.state = true
          }
        }
      }
    },
    'registerObject.userpwd.second.value' (val) {
      if(!this.send){
        if(val.length==0)
        {
          this.registerObject.userpwd.second.message = "必填欄位"
          this.registerObject.userpwd.second.state = false
        }
        else if(val!=this.registerObject.userpwd.first.value)
        {
          this.registerObject.userpwd.second.message = "與第一次密碼不對稱"
          this.registerObject.userpwd.second.state = false
        }
        else
        {
          this.registerObject.userpwd.second.state = true
        }
      }
    }
  },
  methods:{
    // <summary>
    // API Methods
    // </summary>
    // Start //
    verifyLoginProcess(data)
      {
        // console.log(data)
        this.apiLogin(data).then((res)=>{
          const json = JSON.parse(res.data);
          // console.log(json)
          if(json.Status)
          {
            // console.log(json.Data)
            if(this.rememberaccount == "true"){
              // console.log("記住帳號")
              localStorage.setItem('yunlinaccount', this.account.userid);
            }
            sessionStorage.setItem("TokenID", json.Data);
            sessionStorage.setItem("username", this.account.userid);
            this.$router.push({ path: "/" });
            window.location.reload();
          }
          else
          {
            this.waningPopUp(json.Message)
            // console.log("fail")
          }
        })
        .catch((err)=> {
          console.log(err)
        });
    },
    setForgetPasswordEmail(data) {
      // console.log(data)
      this.apiForgetPassword(data)
      .then((res)=>{
        const json = JSON.parse(res.data)
        // console.log(json)
        if(json.Status){
            this.$nextTick(() => {
            this.$bvModal.hide('modal-forgetpassword')
            this.suceessPopUp("已傳送驗證信到該信箱")
          })
        }
        else
        {
          this.$bvModal.hide('modal-forgetpassword')
          this.waningPopUp("此信箱還未註冊")
        }
      })
      .catch((err)=> {
        console.log(err)
      });
    },
    getImageCode(data){
      this.apiImageCode(data)
      .then((res)=>{
        const json = JSON.parse(res.data)
        // this.imageObj = json.Data
        let subObj = JSON.parse(json.Data)
        this.account.imgobj.url = subObj.Image
        this.account.imgobj.hiddenCode = subObj.Code
      })
      .catch((err)=> {
        console.log(err)
      });
    },
    getAccountGroupSignList(data){
      this.apiAccountGroupSignList(data)
      .then((res)=>{
        const json = JSON.parse(res.data)
        // this.imageObj = json.Data
        this.grouplist = this.addDescription(JSON.parse(json.Data))
      })
      .catch((err)=> {
        console.log(err)
      });
    },
    InsertAccount(data) {
      // console.log(data)
      this.apiInsertAccount(data)
        .then((res)=>{
          // console.log("進行中")
          const json = JSON.parse(res.data)
          // console.log(json)
          if(json.Status)
          {
            // console.log(data)
            if(data.AC_GROUP_ID=="4")
            {
              this.suceessPopUp("已傳送驗證信到該信箱")
              this.registerObject = {
                username: {
                  value: null,
                  state: null,
                  message: "必填欄位"
                },
                userpwd: {
                  first: {
                    value: null,
                    state: null,
                    message: "必填欄位"

                  },
                  second: {
                    value: null,
                    state: null,
                    message: "必填欄位"
                  },
                },
                email: {
                  value: null,
                  state: null,
                  message: "必填欄位"
                },
                group: {
                  value: null,
                  state: null,
                  message: "必填欄位"
                },
                phone: {
                  value: null,
                  state: null,
                  message: "必填欄位"
                },
                agency: {
                  value: null,
                  state: null
                },
                role: {
                  value: null,
                  state: null
                },
                subscribile: {
                  value: false,
                  state: null,
                }
              };
              this.send = true;
              setTimeout(() => { this.send = false; }, 1000);
            }
            else
            {
              this.suceessPopUp("已傳送訊息給管理員，請等待管理員驗證")
              this.registerObject = {
                username: {
                  value: null,
                  state: null,
                  message: "必填欄位"
                },
                userpwd: {
                  first: {
                    value: null,
                    state: null,
                    message: "必填欄位"

                  },
                  second: {
                    value: null,
                    state: null,
                    message: "必填欄位"
                  },
                },
                email: {
                  value: null,
                  state: null,
                  message: "必填欄位"
                },
                group: {
                  value: null,
                  state: null,
                  message: "必填欄位"
                },
                phone: {
                  value: null,
                  state: null,
                  message: "必填欄位"
                },
                agency: {
                  value: null,
                  state: null
                },
                role: {
                  value: null,
                  state: null
                },
                subscribile: {
                  value: false,
                  state: null,
                }
              };
              this.send = true;
              setTimeout(() => { this.send = false; }, 1000);
            }
          }
          else
          {
            this.waningPopUp(json.Data)
          }
          this.ifregisterprocess=false
        })
        .catch((err)=> {
          console.log(err)
          this.waningPopUp(err)
          this.ifregisterprocess=false
        });
    },
    setResendCertification(data) {
      // console.log(data)
      this.apiResendCertification(data)
      .then((res)=>{
        const json = JSON.parse(res.data)
        // console.log(json)
        if(json.Status){
            this.$nextTick(() => {
            this.$bvModal.hide('modal-resendemail')
            this.suceessPopUp("已傳送驗證信到該信箱")
          })
        }
        else
        {
          this.$bvModal.hide('modal-resendemail')
          this.waningPopUp(json.Data)
        }
      })
      .catch((err)=> {
        console.log(err)
      });
    },
    // END //
    // delayprocess(value, delay, fn)
    // {
    //   if(value==0)
    //   {
    //     this.throttled(delay, fn)
    //   }
    //   else if(value==1)
    //   {
    //     this.debounced(delay, fn)
    //   }
    // },
    registerprocess:_.debounce(function() {
      console.log("註冊")
      if(this.registerObject.username.state==false || this.registerObject.username.state==null ||
        this.registerObject.group.state==false ||  this.registerObject.group.state==null ||
        this.registerObject.email.state==false || this.registerObject.email.state==null ||
        this.registerObject.phone.state==false || this.registerObject.phone.state==null ||
        this.registerObject.userpwd.first.state==false || this.registerObject.userpwd.first.state==null ||
        this.registerObject.userpwd.second.state==false || this.registerObject.userpwd.second.state==null)
      {
         this.waningPopUp("請將必填欄位填寫完畢或請符合資料格式")
      }
      else
      {
        this.ifregisterprocess=true
        let obj= {
            "AC_USERID": this.registerObject.email.value,
            "AC_USERNAME": this.registerObject.username.value,
            "AC_GROUP_ID": this.registerObject.group.value,
            "AC_CONTENT": this.registerObject.agency.value,
            "AC_TITLE": this.registerObject.role.value,
            "AC_TEL": this.registerObject.phone.value,
            "AC_PWD": this.registerObject.userpwd.first.value,
            "AC_NOTIFY": this.registerObject.subscribile.value.toString()
          }
        // console.log(obj)
        this.FunctionToken(this.InsertAccount, obj)
      }
    }, 500),
    addDescription(value) {
      let list = []
      for(let i in value)
      {
        console.log(i)
        let item = {
          text: value[i]=="農民"?value[i]:value[i].concat(" (需經審核)"),
          value: i
        }
        list.push(item)
      }
      return list
    },
    validEmail(email) {
      // console.log("email正規化")
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    sumbitEvent:_.throttle(function() {
      // console.log([this.account.userid, this.account.passwd, this.account.imgobj.value])
      let loginData = {"Id": this.account.userid,
                        "DecryptionPass" : this.account.passwd,
                        "CodePass": this.account.imgobj.value,
                        "DecryptionCodePass": this.account.imgobj.hiddenCode
                      }
     this.FunctionToken(this.verifyLoginProcess, loginData)
    }, 1000),
    checkFormValidity(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        console.log(re.test(email))
        this.account.emailState = re.test(email)
      },
      resetForgetPasswordModal() {
        this.account.email = null
        this.account.emailState = null
        this.$bvModal.hide('modal-forgetpassword')
      },
      handleForgetPasswordOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        // console.log("Submit事件 ", )
        // console.log(this.account.email)
        // Hide the modal manually
        let item= {
          "AC_USERID": this.account.email
        }
        this.FunctionToken(this.setForgetPasswordEmail, item)
        //alert("Email輸入成功")
      },
      waningPopUp(msg){
        this.messageObject.warning.count = this.dismissSecs
        this.messageObject.warning.content = msg
      },
      suceessPopUp(msg){
        this.messageObject.success.count = this.dismissSecs
        this.messageObject.success.content = msg
      },
      warningCountChanged(count) {
        this.messageObject.warning.count = count
      },
      successCountChanged(count)
      {
        this.messageObject.success.count = count
      },
      resendEmailModal()
      {
        this.account.email = null
        this.account.emailState = null
        this.$bvModal.hide('modal-resendemail')
      },
      handleresendEmailOk(bvModalEvt) {
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleRendEmail()
      },
      handleRendEmail() {
        let item= {
          "AC_USERID": this.account.email
        }
        this.FunctionToken(this.setResendCertification, item)
      },


      loginLine(){

        var data = {};
        this.apiLineOption(data)
        .then((res)=>{
          const json = JSON.parse(res.data)
          console.log(json)

          let client_id = json.client_id;                                    //後台的Channel ID
          let redirect_uri = json.redirect_uri;                              //登入成功後，要導向的網址(必須要和後台設定的一樣，不然會報錯)      
          let authorize_uri = json.authorize_uri;                            //Line官方驗證登入的網址(LINE Login 授權URL)              
          let state = json.state;

          authorize_uri += '?';
          authorize_uri += 'response_type=code';
          authorize_uri += '&client_id=' + client_id;
          authorize_uri += '&redirect_uri=' + redirect_uri;
          authorize_uri += '&state=' + state;
          authorize_uri += '&scope=openid%20profile';
              
          //console.log(authorize_uri);
          window.location.href = authorize_uri;
 
        })
        .catch((err)=> {
          console.log(err)
        });

      },

  }
}
</script>
<style lang="scss" scoped>
  .required:before{
    content: "*";
    color:red;
  }

  .btn-line{
    background: rgb(76, 199, 100)
  }

  .btn-line img{
    height: 29px;
    width: 29px;
  }

</style>